import React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import Image from "../../components/Common/Image";

import { Link } from "react-router-dom";
import { getImageSRC } from "../../functions/assets";

function PostingSingleImageList({ data = [] }) {
  const postings = data && data.length ? data : [];

  return (
    <ImageList
      rowHeight={164}
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        overflowX: "auto",
        p: 0,
        m: 0,
        pb: 2,
      }}
    >
      {postings.map((tile) => (
        <ImageListItem
          key={tile.id}
          component={Link}
          to={`/postings/${tile.id}`}
          sx={(theme) => ({
            backgroundColor: theme.palette.grey[200],
            borderRadius: theme.shape.borderRadius,
            overflow: "hidden",
            width: 164,
            height: 164,
            flex: "0 0 164px",
            ml: 1,
          })}
        >
          {tile.attachments &&
            tile.attachments.map((attachment) => (
              <Image
                src={getImageSRC(attachment.previewFilename)}
                alt={attachment.name}
                key={attachment.id}
                loading="lazy"
                decoding="async"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            ))}
          <ImageListItemBar title={tile.subject} />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

export default PostingSingleImageList;
